export default __webpack_public_path__ + "static/media/news105.2f05d186.jpg";